/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnforcementStatusRecord } from './enforcementStatusRecord';


export interface EnforcementStatusResponse { 
    enforcement_status_records?: Array<EnforcementStatusRecord>;
    total_record_count?: number;
}

